import { MoreHorizontal } from "lucide-react";

import { Badge } from "@components/badge/badge";
import { Button } from "@components/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@components/dropdown-menu/dropdown-menu";
import { TableCell, TableRow } from "@components/table/table";

export function SearchRequestRow({ product }: { product: any }) {
  return (
    <TableRow>
      <TableCell className="hidden md:table-cell">{product.remessa}</TableCell>

      <TableCell className="font-medium">{product.cliente}</TableCell>
      <TableCell>{product.situacao}</TableCell>

      <TableCell className="hidden md:table-cell">{product.solicitante}</TableCell>

      <TableCell className="hidden md:table-cell">
        <Badge className="bg-green-500 text-center">{product.status}</Badge>
      </TableCell>

      <TableCell className="hidden md:table-cell">{product.quantidadeSolicitacao}</TableCell>

      <TableCell className="hidden md:table-cell">{product.tecnologia}</TableCell>
      <TableCell className="hidden md:table-cell">{product.posicao}</TableCell>

      <TableCell className="hidden md:table-cell">{product.dataSolicitacao}</TableCell>

      <TableCell>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button aria-haspopup="true" size="icon" variant="ghost">
              <MoreHorizontal className="h-4 w-4" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Ações</DropdownMenuLabel>
            <DropdownMenuItem>Pegar tarefa</DropdownMenuItem>
            <DropdownMenuItem>
              <form>
                <button type="submit">Excluir</button>
              </form>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
}
